'use strict';
import React from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import Icon from 'components/clarity-ui/components/icon';

/**
 *
 * Usage:
 *
 * ```Javascript
 * <SiteNavigationMenuItem menuName iconClass linkTo isActive>
 * 	{ Children }
 * </SiteNavigationMenuItem>
 * ```
 *
 * @extends {React.Component}
 * @property {String} menuType Defines whether to render the Navigation Item as part of menu or subMenu.
 * @property {String} menuName Sets the name of the item to render.
 * @property {String} iconClass Renders the specified icon for the Item.
 * @property {String} linkTo Defines the path where to redirect.
 * @property {Boolean} isActive Renders the Navigation Item as active.
 */
class SiteNavigationMenuItem extends React.Component {

  /**
   * @return {String} List CSS classname.
   */
  getListClassName (isActive, menuType) {
    return classNames({
      [`SiteNavigation-${menuType}Item`]: true,
      'is-active': isActive
    });
  }

  /**
   * @return {String} Anchor CSS classname.
   */
  getAnchorClassName (menuType) {
    return classNames({
      [`SiteNavigation-${menuType}Link`]: true
    });
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { children, iconClass, isActive, linkTo, menuName, menuType, ...otherProps } = this.props;
    return (
      <li {...otherProps} className={this.getListClassName(isActive, menuType)}>
        <Link className={this.getAnchorClassName(menuType)} to={linkTo}>
          {menuType === 'menu' ? <Icon className="SiteNavigation-menuIcon" iconClass={iconClass} /> : null}
          { menuName }
        </Link>
        { children }
      </li>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the SiteNavigationMenuItem component
 */
SiteNavigationMenuItem.propTypes = {
  iconClass: React.PropTypes.string,
  isActive: React.PropTypes.bool,
  linkTo: React.PropTypes.string.isRequired,
  menuName: React.PropTypes.string,
  menuType: React.PropTypes.oneOf(['menu', 'subMenu'])
};

SiteNavigationMenuItem.defaultProps = {
  isActive: false,
  menuType: 'menu'
};

export default SiteNavigationMenuItem;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/siteNavigation/siteNavigationMenuItem.jsx